import React, { useState } from "react";
import NavBar from "./NavBar";
import Footer from "./Footer";
import "./Contact.css";
import api from "./Dashboard/Api";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarkerAlt,
  faPhone,
  faEnvelope,
  faClock,
  faUser,
  faComment,
  faPaperPlane
} from "@fortawesome/free-solid-svg-icons";

const Contact = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    Phone: "",
    email: "",
    message: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      Name: formData.name,
      Phone: formData.Phone,
      Email: formData.email,
      Message: formData.message,
      SubmittedAt: new Date().toISOString(),
    };

    try {
      const response = await api.post(
        "/api/shared/Home/ContactUs",
        payload,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      alert("✅ Success: " + response.data.message);
      setFormData({
        name: "",
        Phone: "",
        email: "",
        message: ""
      });
    } catch (error) {
      console.error("❌ Error:", error);
      alert("❌ Something went wrong, try again!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      <NavBar />
      
      {/* Hero Section - تم التصحيح */}
      <section className="contact-hero">
        <div className="contact-hero-overlay"></div>
        <div className="container">
          <div className="contact-hero-content">
            <h1>Get in Touch</h1>
            <p>Let's ignite your brand's potential together</p>
          </div>
        </div>
      </section>

      {/* Contact Content */}
      <section className="contact-content">
        <div className="container">
          <div className="contact-grid">
            <div className="page-contact-info">
              <h2>Let's Start a Conversation</h2>
              <p>Have questions about our advertising solutions? We're here to help and answer any questions you might have.</p>
              
              <div className="info-item">
                <div className="info-icon">
                  <FontAwesomeIcon icon={faMapMarkerAlt} />
                </div>
                <div className="info-details">
                  <h4>Our Location</h4>
                  <p>Sheikh Zayed, 8th District, 1st Neighborhood, Building 42</p>
                </div>
              </div>
              
              <div className="info-item">
                <div className="info-icon">
                  <FontAwesomeIcon icon={faPhone} />
                </div>
                <div className="info-details">
                  <h4>Phone Number</h4>
                  <p>+20 112 384 6472</p>
                </div>
              </div>
              
              <div className="info-item">
                <div className="info-icon">
                  <FontAwesomeIcon icon={faEnvelope} />
                </div>
                <div className="info-details">
                  <h4>Email Address</h4>
                  <p>spark@gmail.com</p>
                </div>
              </div>
              
              <div className="info-item">
                <div className="info-icon">
                  <FontAwesomeIcon icon={faClock} />
                </div>
                <div className="info-details">
                  <h4>Working Hours</h4>
                  <p>Sunday - Thursday: 9AM - 5PM</p>
                </div>
              </div>
            </div>
            
            <div className="contact-form-wrapper">
              <div className="form-header">
                <h3>Send Us a Message</h3>
                <p>Fill out the form below and we'll get back to you as soon as possible</p>
              </div>
              
              <form className="spark-contact-form" onSubmit={handleSubmit}>
                <div className="spark-form-group">
                  <FontAwesomeIcon icon={faUser} className="spark-input-icon" />
                  <input
                    type="text"
                    id="spark-name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="spark-form-input"
                    required
                  />
                  <label htmlFor="spark-name" className={formData.name ? "spark-label filled" : "spark-label"}>Name</label>
                </div>

                <div className="spark-form-group">
                  <FontAwesomeIcon icon={faPhone} className="spark-input-icon" />
                  <input
                    type="tel"
                    id="spark-phone"
                    name="Phone"
                    value={formData.Phone}
                    onChange={handleChange}
                    className="spark-form-input"
                    required
                  />
                  <label htmlFor="spark-phone" className={formData.Phone ? "spark-label filled" : "spark-label"}>Phone Number</label>
                </div>

                <div className="spark-form-group">
                  <FontAwesomeIcon icon={faEnvelope} className="spark-input-icon" />
                  <input
                    type="email"
                    id="spark-email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="spark-form-input"
                    required
                  />
                  <label htmlFor="spark-email" className={formData.email ? "spark-label filled" : "spark-label"}>Email Address</label>
                </div>

                <div className="spark-form-group">
                  <FontAwesomeIcon icon={faComment} className="spark-input-icon" />
                  <textarea
                    id="spark-message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="spark-form-textarea"
                    rows={4}
                    required
                  />
                  <label htmlFor="spark-message" className={formData.message ? "spark-label filled" : "spark-label"}>How Can We Help You?</label>
                </div>

                <button
                  className="spark-submit-btn"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Sending..." : "Send Message"}
                  <FontAwesomeIcon icon={faPaperPlane} style={{marginLeft: '10px'}} />
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;